import { useConfig } from "../components"

export const supportMulticam = (program: any, channel: any, matchStatus: any) => {
    const { getConfig } = useConfig()
    return getConfig()?.eplFeatures?.multiCamValue > 0 && 
        program?.isGame?.() &&
        program?.isMultiCamSupported?.() &&
        !program?.isVod?.() &&
        program?.isLive?.() &&
        // program?.isLiveNow?.() && /** Multicam should be supported for catchups as well so commenting this */
        channel?.multiCamRef &&
        channel?.multiCamRef?.length > 0
}
